<template>
  <div v-if="superAdmin || userRole == 'admin'">
      <v-layout wrap row justify-start  pa-4>
        <v-flex xs12 px-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Send Bulk WA by Messages
						</v-card-title>
            <v-card-text>
              <v-layout row wrap>
								<v-flex xs12 md12 pa-1>
									<v-text-field
										label="Agent"
										solo
										hide-details
										disabled
                    :loading="loading"
										v-model="userName"
									></v-text-field>
              	</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-text-field
										label="Delimiter"
										solo
										disabled
										hide-details
                    :loading="loading"
										v-model="delimiter"
									></v-text-field>
              	</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-textarea
										label="Message"
										v-model="message"
										solo
									></v-textarea>
              	</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-textarea
										label="Key/Number & Message/Variable CSV"
										v-model="pastedData"
										solo
									></v-textarea>
              	</v-flex>
								<v-flex xs12 class="text-xs-center">
									{{logger}}
								</v-flex>
								<v-flex xs12>
									<div v-for="k in pKeys" :key="k">{{k}}</div>
								</v-flex>
              </v-layout>
            </v-card-text>
						<v-card-actions>
              <v-spacer></v-spacer>
							<v-btn @click="sendBulk()" :loading="loading" color="success" dark>
                send
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate, sleep} from '@/customFunction';
import countriesJSON from '@/countries-ash.json'
import axios from 'axios';
const headers = {
  'Accept': 'application/json'
}
export default {
  data(){
    return {
			loading: false,
			pastedData:null,
			delimiter:',',
			logger:null,
			pKeys:[],
			countriesFullLoaded:countriesJSON,
			taxrates:null,
			last:null,
			message:null,
			limit:3,
			loops:2
    }
  },
  methods: {
		
		guessDelimiters (text, possibleDelimiters) {
			return possibleDelimiters.filter(weedOut);
			function weedOut (delimiter) {
				var cache = -1;
				return text.split('\n').every(checkLength);
				function checkLength (line) {
					if (!line) {
							return true;
					}
					var length = line.split(delimiter).length;
					if (cache < 0) {
							cache = length;
					}
					return cache === length && length > 1;
				}
			}
		},
		getArray(){
			let csv = this.pastedData
			let dels = [' ', '  ', ',', '	', '\t']
			this.delimiter = ','
			if(this.delimiter && this.delimiter > 1) {
				this.$emit('snackbarNotification', `Please export as CSV`, 'error')
				return
			}
			var lines=csv.split("\n");
			var result = [];
			var headers=lines[0].split(this.delimiter);
			for(var i=1;i<lines.length;i++){
					if (!lines[i])
							continue
					var obj = {};
					var currentline=lines[i].split(this.delimiter);
					for(var j=0;j<headers.length;j++){
							obj[headers[j]] = currentline[j];
					}
					result.push(obj);
			}
			console.log(result);
			return result
		},
		async replaceVars(msg, send){
			return new Promise(async (res, rej)=>{
				let vars = Object.keys(send)
				for (let i = 0; i < vars.length; i++) {
					const v = vars[i];
					msg = msg.replace(`*|${v}|*`, send[v])
					console.log(v, msg, send[v])
				}
				res(msg)
			})
		},
		async sendBulk(){
      let data = this.getArray();
      (async x=>{
        this.logger = `0/${data.length}`
        for (let i = 0; i < data.length; i++) {
          const send = data[i];
					let num
					let lead
					if(send.number) {
          	num = send.number
					} else if(send.key){
						lead = await store.collection('leads').doc(send.key).get().then(x=>x.data())
          	num = lead.wa_number ? lead.wa_number : lead.phone_number_1
					}
          let template = {
            name:`starting`,
            namespace:`b9796543_bcb1_4152_bd49_66173da70fd8`,
            language:`ar`,
            components:[
              {
                type: "body",
                parameters: [
                    {
                        type: "text",
                        text: this.message ? await this.replaceVars(this.message, send) : send.message,
                    }
                ]
              }
            ]
          }
          let post = {
            message: this.message ? await this.replaceVars(this.message, send) : send.message,
            number: num,
            country: send.number ? 'NINJA USER' : lead ? lead.company_code : 'NONE',
            user: 'system',
            template
          }
					console.log(post)
          await sleep(10000)
          // try {
          //   console.log('key', send.key, 'message', send.message)
          //   let r = await axios.post(`// WA API //`, post, {headers}).then(x=>x.data)
          //   console.log('key', send.key, 'result', r)
          //   this.pKeys.push(send.key)
          // } catch (error) {
            
          // }
          this.logger = `${i+1}/${data.length}`
        }
      })()
    }
  },
  props:{
		superAdmin:{
			required:true
		},
		userName:{
			default:null
		},
    userRole:{
			default:null
		},
  },
  computed:{
    
  },
  async created(){

  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
